export function Footer() {
  return (
    <footer className="bg-salt-dark text-gray-300 border-t-8 border-salt-orange">
      <div className="bg-plant-green/10 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
            <div className="col-span-1 md:col-span-2">
              <div className="flex gap-4 items-center mb-6">
                <img
                  src="https://vibe.filesafe.space/1774883178162043817/attachments/143fc069-80c1-443b-8bda-33476d8a66fb.png"
                  alt="911 Sourcing Logo"
                  className="h-24 w-auto"
                />
              </div>
              <p className="mt-4 text-gray-400 max-w-md text-sm leading-relaxed">
                Specialized logistics for the green and snow industries. We
                track down what you need, when you need it most. Period.
              </p>
            </div>
            <div>
              <h2 className="text-white text-xs font-black uppercase tracking-widest mb-6">
                Services
              </h2>
              <ul className="space-y-4 text-sm font-bold">
                <li>
                  <a
                    className="hover:text-salt-orange transition-colors"
                    href="/salt-supply"
                  >
                    Emergency Salt
                  </a>
                </li>
                <li>
                  <a
                    className="hover:text-plant-lime transition-colors"
                    href="/plant-finder"
                  >
                    Plant Sourcing
                  </a>
                </li>
                <li>
                  <a
                    className="hover:text-blue-400 transition-colors"
                    href="/ai-receptionist"
                  >
                    AI Receptionist
                  </a>
                </li>
                <li>
                  <a
                    className="hover:text-blue-300 transition-colors"
                    href="/mini-weather-station"
                  >
                    Weather Station
                  </a>
                </li>
                <li>
                  <a
                    className="hover:text-plant-green transition-colors"
                    href="/kujo-apparel"
                  >
                    Kujo Apparel
                  </a>
                </li>
                <li>
                  <a
                    className="hover:text-salt-orange transition-colors"
                    href="https://store.911sourcing.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    911 Store
                  </a>
                </li>
                <li>
                  <a
                    className="hover:text-white transition-colors"
                    href="/how-it-works"
                  >
                    Our Process
                  </a>
                </li>
                <li>
                  <a
                    className="hover:text-white transition-colors"
                    href="/service-areas"
                  >
                    Coverage Map
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h2 className="text-white text-xs font-black uppercase tracking-widest mb-6">
                Support
              </h2>
              <ul className="space-y-4 text-sm font-medium">
                <li>Office: 9am - 4pm EST</li>
                <li>Storms: 24/7 Dispatch</li>
                <li className="text-xs">
                  <span className="text-gray-400 block uppercase font-black tracking-widest mb-1">
                    Salt:
                  </span>
                  info@911saltsupply.com
                </li>
                <li className="text-xs">
                  <span className="text-gray-400 block uppercase font-black tracking-widest mb-1">
                    Plants:
                  </span>
                  info@911plantfinder.com
                </li>
                <li className="text-white font-black text-lg pt-2">
                  (888) 491-0911
                </li>
                <li className="text-[10px] text-gray-400 pt-4 leading-tight">
                  120 Marketplace Cir Ste-132
                  <br />
                  Georgetown, KY 40324
                </li>
                <li className="pt-4 flex flex-col space-y-2">
                  <a
                    className="text-[10px] uppercase font-black tracking-widest hover:text-white transition-colors"
                    href="/terms"
                  >
                    Terms of Service
                  </a>
                  <a
                    className="text-[10px] uppercase font-black tracking-widest hover:text-white transition-colors"
                    href="/privacy"
                  >
                    Privacy Policy
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="mt-16 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center text-[10px] font-black uppercase tracking-widest text-gray-400">
            <p>© 2026 911 Sourcing.</p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a className="hover:text-white" href="/terms">
                Terms
              </a>
              <a className="hover:text-white" href="/privacy">
                Privacy
              </a>
              <a
                className="hover:text-white"
                href="https://store.911sourcing.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Store
              </a>
              <a className="hover:text-white" href="/contact">
                Contact
              </a>
              <a className="hover:text-white" href="/service-areas">
                Coverage
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
